/**
 * Feature requests (WP4-FEEDBACK): the practice's list of staff feature
 * requests and bug reports, filed from the top-bar button. Everyone can
 * read and comment; managers (`feedback.manage`) set status and priority.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'feedback',
    title: 'Feature requests',
    version: '0.1.0',
    owner: 'WP4-FEEDBACK',
    entitlementKey: null,
    permissions: ['feedback.manage'],
    routes: [
      {
        id: 'list',
        path: '/feedback',
        title: 'Feature requests',
        officeScope: 'location-or-all',
        readsPhi: false,
      },
    ],
    nav: [
      {
        label: 'Feature requests',
        group: 'meta',
        routeId: 'list',
        icon: 'lightbulb',
        order: 90,
      },
    ],
    commands: [
      {
        id: 'feedback.open',
        title: 'Go to Feature requests',
        keywords: ['feature request', 'bug report', 'feedback', 'suggestion', 'idea'],
        routeId: 'list',
      },
    ],
    sseEntityKeys: ['feature_request'],
    phiReadPoints: [],
  }),
  pages: {
    list: () => import('./FeedbackPage.js'),
  },
});
